import { uuid } from '../utils';
import {
  ANIMATION
} from './categories';

export default {
  id: uuid(),
  priority: 1,
  name: '3rd Date',
  thumbnail: './3rdDate/3rdDate_Thumb.jpg',
  categories: [ ANIMATION ],
  content: [
    'https://vimeo.com/243323371'
  ]
};




// WEBPACK FOOTER //
// ./src/projects/3rddate.js